//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const BackfillLegacyViewTypeSegments: FeatureFlag = {"Id":"BackfillLegacyViewTypeSegments","Label":"[10.27]Backfill legacy view-type segments","Impact":"For submissions whose ViewType entries predate stored segments, backfill Segment by matching the live form definition before applying segment-based document access. Off by default for performance; enable per tenant if legacy submissions need their view-type segments backfilled for segment access restrictions to apply correctly.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":1};
